import ImageCreatorPage from "./ImageCreatorPage"

export default ImageCreatorPage